// Chat integration types.
export enum ChatIntegrationTypes {
    NONE = 'None',
    LIVE_CHAT = 'LiveChat'
}

// Email integration types.
export enum EmailIntegrationTypes {
    NONE = 'None',
    POP_3 = 'POP3 SMTP'
}
